<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import CardContent from "../components/CardContent.svelte"
  import Navbar from "../components/Navbar.svelte"
  import Spinner from "../components/Spinner.svelte"
  import getFecha from "../services/fecha"
  import { formatNumber } from "../services/formatNumber"
  import { descargarTXT } from "../services/txt"
  import { user } from "../stores/user"
  import Modal from "../components/Modal.svelte"
  import { BASE_URL } from "../stores/BASE_URL"

  let consultas = []
  let consultas_descargar = []

  let sesiones = []
  let sesiones_descargar = []

  let actividades = []
  let actividades_descargar = []

  let actividades_usuarios = []
  let actividades_usuarios_descargar = []

  let actividades_sesiones_descargar = []

  let actividades_buscar_por_ip = []

  let modal_usuarios_por_ip = {
    usuarios: [],
    is_open: false,
    isLoading: false,
  }

  let fecha = "0001-01-01"
  let fecha_fin = "0001-01-01"
  let tipo = "consultas"
  let tipo_sesion = "1"
  let ip_sospechosa = ""

  let isLoading = false
  let isDowloading = false

  const getConsultas = async () => {
    isLoading = true
    const response = await apiFetch(
      `${BASE_URL}consulta.php?action=getConsultasDiarias&fecha=${fecha}`
    )
    const resp = await response.json()
    consultas = resp.data
    isLoading = false
  }

  const descargarConsultas = async () => {
    isDowloading = true
    const response = await apiFetch(
      `${BASE_URL}consulta.php?action=descargarConsultasDiarias&fecha=${fecha}`
    )
    const resp = await response.json()
    consultas_descargar = resp.data
    let texto = []
    texto.push(
      "Fecha" + "\t" + "Cliente" + "\t" + "Usuario" + "\t" + "Consultas"
    )
    for (let d of consultas_descargar) {
      texto.push(
        "\n" +
          d.fecha +
          "\t" +
          d.cliente +
          "\t" +
          d.usuario +
          "\t" +
          d.consultas
      )
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    descargarTXT(txt, `${fecha}_reporte-consultas`)
    isDowloading = false
  }

  const getSesiones = async () => {
    isLoading = true
    const response = await apiFetch(
      `${BASE_URL}consulta.php?action=getSesionesDiarias&fecha=${fecha}&tipo_sesion=${tipo_sesion}`
    )
    const resp = await response.json()
    sesiones = resp.data
    isLoading = false
  }

  const descargarSesiones = async () => {
    isDowloading = true
    const response = await apiFetch(
      `${BASE_URL}consulta.php?action=descargarSesionesDiarias&fecha=${fecha}`
    )
    const resp = await response.json()
    sesiones_descargar = resp.data
    let texto = []
    texto.push(
      "Cliente" +
        "\t" +
        "Usuario" +
        "\t" +
        "Nombres" +
        "\t" +
        "IP" +
        "\t" +
        "Estado" +
        "\t" +
        "Fecha"
    )
    for (let d of sesiones_descargar) {
      texto.push(
        "\n" +
          d.razon_social +
          "\t" +
          d.usuario +
          "\t" +
          d.nombres +
          "\t" +
          d.ip +
          "\t" +
          d.estado +
          "\t" +
          d.fecha
      )
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    descargarTXT(txt, `${fecha}_reporte-sesiones`)
    isDowloading = false
  }

  const getActividad = async () => {
    isLoading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getActividadSospechosa&inicio=${fecha}&fin=${fecha_fin}`
    )
    const resp = await response.json()
    actividades = resp.data
    isLoading = false
  }

  const descargarActividad = async () => {
    isDowloading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getActividadSospechosa&inicio=${fecha}&fin=${fecha_fin}`
    )
    const resp = await response.json()
    actividades_descargar = resp.data
    let texto = []
    texto.push("IP" + "\t" + "Cantidad de clientes")
    for (let d of actividades_descargar) {
      texto.push("\n" + d.ip + "\t" + d.cantidad)
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    descargarTXT(txt, `${fecha}_reporte-actividad-sospechosa`)
    isDowloading = false
  }

  const descargarSesionesSospechosasPorIp = async (ip) => {
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getSesionesSospechosasPorIp&ip=${ip}`
    )
    const resp = await response.json()
    actividades_sesiones_descargar = resp.data
    let texto = []
    texto.push(
      "IP" +
        "\t" +
        "Usuario" +
        "\t" +
        "Documento" +
        "\t" +
        "Nombres" +
        "\t" +
        "Razón Social" +
        "\t" +
        "fecha"
    )
    for (let d of actividades_sesiones_descargar) {
      texto.push(
        "\n" +
          d.ip +
          "\t" +
          d.usuario +
          "\t" +
          d.documento +
          "\t" +
          d.nombres +
          "\t" +
          d.razon_social +
          "\t" +
          d.fecha
      )
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    descargarTXT(txt, `${fecha}_reporte-sesiones-sospechosas`)
  }

  const descargarBuscarPorIp = async () => {
    isDowloading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getBuscarPorIp&ip=${ip_sospechosa}&inicio=${fecha}&fin=${fecha_fin}`
    )
    const resp = await response.json()
    actividades_buscar_por_ip = resp.data
    let texto = []
    texto.push(
      "Cliente" +
        "\t" +
        "Usuario" +
        "\t" +
        "IP" +
        "\t" +
        "Estado" +
        "\t" +
        "Total accesos"
    )
    for (let d of actividades_buscar_por_ip) {
      texto.push(
        "\n" +
          d.razon_social +
          "\t" +
          d.usuario +
          "\t" +
          d.ip +
          "\t" +
          d.estado +
          "\t" +
          d.cantidad
      )
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    descargarTXT(txt, `${fecha}_reporte-buscar-por-ip`)
    isDowloading = false
  }

  const getActividadSospechosaUsuario = async () => {
    isLoading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getActividadSospechosaUsuario&fecha=${fecha}`
    )
    const resp = await response.json()
    actividades_usuarios = resp.data
    isLoading = false
  }

  const descargarActividadSospechosaUsuario = async () => {
    isDowloading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getActividadSospechosaUsuario&fecha=${fecha}`
    )
    const resp = await response.json()
    actividades_usuarios_descargar = resp.data
    let texto = []
    texto.push("Fecha" + "\t" + "Cliente" + "\t" + "Usuario" + "\t" + "IPs")
    for (let d of actividades_usuarios_descargar) {
      texto.push(
        "\n" + d.fecha + "\t" + d.razon_social + "\t" + d.usuario + "\t" + d.ips
      )
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    descargarTXT(txt, `${fecha}_reporte-actividad-sospechosa-usuarios`)
    isDowloading = false
  }

  const getUsuariosPorIp = async (ip) => {
    modal_usuarios_por_ip.usuarios = []
    modal_usuarios_por_ip.is_open = true
    modal_usuarios_por_ip.isLoading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getUsuariosPorIp&ip=${ip}`
    )
    const resp = await response.json()
    modal_usuarios_por_ip.usuarios = resp.data
    modal_usuarios_por_ip.isLoading = false
  }

  const getBuscarPorIp = async () => {
    isLoading = true
    const response = await apiFetch(
      `${BASE_URL}reporte.php?action=getBuscarPorIp&ip=${ip_sospechosa}&inicio=${fecha}&fin=${fecha_fin}`
    )
    const resp = await response.json()
    actividades_buscar_por_ip = resp.data
    isLoading = false
  }

  const handleBuscar = () => {
    switch (tipo) {
      case "consultas":
        getConsultas()
        break
      case "sesiones":
        getSesiones()
        break
      case "actividad":
        getActividad()
        break
      case "actividad_usuario":
        getActividadSospechosaUsuario()
        break
      case "buscar_por_ip":
        getBuscarPorIp()
        break
    }
  }

  const handleDescargar = () => {
    switch (tipo) {
      case "consultas":
        descargarConsultas()
        break
      case "sesiones":
        descargarSesiones()
        break
      case "actividad":
        descargarActividad()
        break
      case "actividad_usuario":
        descargarActividadSospechosaUsuario()
        break
      case "buscar_por_ip":
        descargarBuscarPorIp()
        break
    }
  }

  fecha = getFecha()
  fecha_fin = getFecha()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }
  })
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Reporte diario">
      <div class="row g-2">
        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
          <select class="form-select" bind:value={tipo}>
            <option value="consultas">Consultas</option>
            <option value="sesiones">Sesiones</option>
            <option value="actividad">Actividad sospechosa (IP)</option>
            <option value="actividad_usuario"
              >Actividad sospechosa (Usuario)</option
            >
            <option value="buscar_por_ip">Buscar por IP</option>
          </select>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-6">
          <div class="row g-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-auto">
              <input type="date" class="form-control" bind:value={fecha} />
            </div>
            <div
              class="col-12 col-sm-6 col-md-6 col-lg-auto {tipo ==
                'actividad' || tipo == 'buscar_por_ip'
                ? ''
                : 'd-none'}"
            >
              <input type="date" class="form-control" bind:value={fecha_fin} />
            </div>
            <div
              class="col-12 col-sm-6 col-md-6 col-lg-auto {tipo == 'sesiones'
                ? ''
                : 'd-none'}"
            >
              <div
                class="btn-group"
                role="group"
                aria-label="Basic checkbox toggle button group"
              >
                <input
                  type="radio"
                  class="btn-check"
                  name="tipo_sesion"
                  id="option-exito"
                  autocomplete="off"
                  value="1"
                  bind:group={tipo_sesion}
                />
                <label class="btn btn-outline-success" for="option-exito"
                  ><i class="bi bi-check"></i></label
                >

                <input
                  type="radio"
                  class="btn-check tn-check-sm"
                  name="tipo_sesion"
                  id="option-error"
                  autocomplete="off"
                  value="0"
                  bind:group={tipo_sesion}
                />
                <label class="btn btn-outline-danger" for="option-error"
                  ><i class="bi bi-x"></i></label
                >
              </div>
            </div>
            <div
              class="col-12 col-sm-6 col-md-6 col-lg-auto {tipo ==
              'buscar_por_ip'
                ? ''
                : 'd-none'}"
            >
              <input
                type="text"
                class="form-control"
                bind:value={ip_sospechosa}
                placeholder="IP sospechosa"
              />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 text-end">
          {#if isLoading}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Cargando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={handleBuscar}>
              <i class="bi bi-search" /> Buscar
            </button>
          {/if}

          {#if isDowloading}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Descargando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={handleDescargar}>
              <i class="bi bi-download"></i> Descargar
            </button>
          {/if}
        </div>
      </div>

      <div class="table-responsive mt-3">
        {#if tipo == "consultas"}
          <table class="table table-bordered table-sm table-striped small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th scope="col">Fecha</th>
                <th scope="col">Cliente</th>
                <th scope="col">Usuario</th>
                <th scope="col">Consultas</th>
              </tr>
            </thead>
            <tbody>
              {#if isLoading}
                <tr>
                  <td colspan="4">
                    <Spinner message="Cargando" />
                  </td>
                </tr>
              {:else}
                {#if consultas.length === 0}
                  <tr>
                    <td colspan="4" class="text-center text-secondary">
                      <p>No hay registros</p>
                    </td>
                  </tr>
                {/if}
                {#each consultas as consulta}
                  <tr>
                    <td>{consulta.fecha}</td>
                    <td>{consulta.cliente}</td>
                    <td>{consulta.usuario}</td>
                    <td class="text-end">{formatNumber(consulta.consultas)}</td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        {:else if tipo == "actividad"}
          <table class="table table-bordered table-sm table-striped small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th scope="col">IP</th>
                <th scope="col">Cantidad de clientes</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {#if isLoading}
                <tr>
                  <td colspan="3">
                    <Spinner message="Cargando" />
                  </td>
                </tr>
              {:else}
                {#if actividades.length === 0}
                  <tr>
                    <td colspan="3" class="text-center text-secondary">
                      <p>No hay registros</p>
                    </td>
                  </tr>
                {/if}
                {#each actividades as actividad}
                  <tr>
                    <td>{actividad.ip}</td>
                    <td class="text-end">{formatNumber(actividad.cantidad)}</td>
                    <td class="text-end">
                      <button
                        class="btn btn-primary py-0"
                        on:click={() =>
                          descargarSesionesSospechosasPorIp(actividad.ip)}
                      >
                        <i class="bi bi-download my-0"></i>
                      </button>
                    </td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        {:else if tipo == "actividad_usuario"}
          <table class="table table-bordered table-sm table-striped small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th scope="col">Fecha</th>
                <th scope="col">Cliente</th>
                <th scope="col">Usuario</th>
                <th scope="col">IPs</th>
              </tr>
            </thead>
            <tbody>
              {#if isLoading}
                <tr>
                  <td colspan="4">
                    <Spinner message="Cargando" />
                  </td>
                </tr>
              {:else}
                {#if actividades_usuarios.length === 0}
                  <tr>
                    <td colspan="4" class="text-center text-secondary">
                      <p>No hay registros</p>
                    </td>
                  </tr>
                {/if}
                {#each actividades_usuarios as actividad}
                  <tr>
                    <td>{actividad.fecha}</td>
                    <td>{actividad.razon_social}</td>
                    <td>{actividad.usuario}</td>
                    <td class="text-end">{formatNumber(actividad.ips)}</td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        {:else if tipo == "buscar_por_ip"}
          <table class="table table-bordered table-sm table-striped small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th scope="col">Cliente</th>
                <th scope="col">Usuario</th>
                <th scope="col">IP</th>
                <th scope="col">Estado</th>
                <th scope="col">Total accesos</th>
              </tr>
            </thead>
            <tbody>
              {#if isLoading}
                <tr>
                  <td colspan="5">
                    <Spinner />
                  </td>
                </tr>
              {:else}
                {#each actividades_buscar_por_ip as u}
                  <tr>
                    <td>{u.razon_social}</td>
                    <td>{u.usuario}</td>
                    <td>{u.ip}</td>
                    <td>
                      {#if u.estado == "1"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                        >
                          Exitoso
                        </small>
                      {:else if u.estado == "0"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                        >
                          Error
                        </small>
                      {/if}
                    </td>
                    <td class="text-end">{formatNumber(u.cantidad)}</td>
                  </tr>
                {:else}
                  <tr>
                    <td colspan="5" class="text-center text-secondary">
                      · · · No se encontraron resultados · · ·
                    </td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        {:else}
          <table class="table table-bordered table-sm table-striped small">
            <thead>
              <tr class="text-secondary fw-normal">
                <th scope="col">Fecha</th>
                <th scope="col">Cliente</th>
                <th scope="col">Usuario</th>
                <th scope="col">Nombres</th>
                <th scope="col">IP</th>
                <th scope="col">Estado</th>
                <th scope="col">Total de registros</th>
              </tr>
            </thead>
            <tbody>
              {#if isLoading}
                <tr>
                  <td colspan="7">
                    <Spinner message="Cargando" />
                  </td>
                </tr>
              {:else}
                {#if sesiones.length === 0}
                  <tr>
                    <td colspan="7" class="text-center text-secondary">
                      <p>No hay registros</p>
                    </td>
                  </tr>
                {/if}
                {#each sesiones as sesion}
                  <tr>
                    <td>{sesion.fecha}</td>
                    <td>{sesion.razon_social}</td>
                    <td>{sesion.usuario}</td>
                    <td>{sesion.nombres}</td>
                    <td
                      ><button
                        class="btn btn-sm py-0 text-primary"
                        on:click={() => getUsuariosPorIp(sesion.ip)}
                        >{sesion.ip}</button
                      ></td
                    >
                    <td>
                      {#if sesion.estado == "1"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                        >
                          Exitoso
                        </small>
                      {:else if sesion.estado == "0"}
                        <small
                          class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                        >
                          Error
                        </small>
                      {/if}
                    </td>
                    <td class="text-end">
                      {formatNumber(sesion.total_registros)}
                    </td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        {/if}
      </div>
    </CardContent>

    <Modal isOpen={modal_usuarios_por_ip.is_open}>
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              on:click={() => {
                modal_usuarios_por_ip.is_open = false
              }}
            />
          </div>
          <div class="modal-body bg-light">
            <div class="table resopnsive">
              <table class="table table-bordered table-sm table-striped small">
                <thead>
                  <tr class="text-secondary fw-normal">
                    <th scope="col">Cliente</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">IP</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Total de registros</th>
                  </tr>
                </thead>
                <tbody>
                  {#if modal_usuarios_por_ip.isLoading}
                    <tr>
                      <td colspan="5">
                        <Spinner />
                      </td>
                    </tr>
                  {:else}
                    {#each modal_usuarios_por_ip.usuarios as u}
                      <tr>
                        <td>{u.razon_social}</td>
                        <td>{u.usuario}</td>
                        <td>{u.ip}</td>
                        <td>
                          {#if u.estado == "1"}
                            <small
                              class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                            >
                              Exitoso
                            </small>
                          {:else if u.estado == "0"}
                            <small
                              class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                            >
                              Error
                            </small>
                          {/if}
                        </td>
                        <td class="text-end">{formatNumber(u.cantidad)}</td>
                      </tr>
                    {:else}
                      <tr>
                        <td colspan="5" class="text-center text-secondary">
                          · · · No se encontraron resultados · · ·
                        </td>
                      </tr>
                    {/each}
                  {/if}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
{/if}
